import * as React from 'react'

import styled from '@emotion/styled'

import { colors } from '../constants'
import { NativeLink, Text } from '../typography'

const ErrorText = styled(Text)`
  color: ${colors.text.error};
`

export const LINK_REGEX = /(\[[^\]]*\]\([^\)]*\))/g
export const LINK_NAME_REGEX = /\[(.*?)\]/
export const LINK_HREF_REGEX = /\((.*?)\)/

interface IProps {
  target?: '_self' | '_blank'
  children: string
  onClick?: () => void
  errorText?: boolean
}

export default function TextWithLinks(props: IProps) {
  const { children, onClick, errorText } = props
  const stringArray = children.replace(LINK_REGEX, match => `|${match}|`).split('|')

  return (
    <>
      {stringArray.map((s, i) => {
        if (s.match(LINK_REGEX)) {
          const [name, href] = [
            (LINK_NAME_REGEX.exec(s) || [])[1],
            (LINK_HREF_REGEX.exec(s) || [])[1],
          ]

          return (
            <NativeLink
              key={i}
              href={href}
              target={props.target || '_blank'}
              onClick={
                onClick
                  ? e => {
                      e.preventDefault()
                      onClick()
                    }
                  : undefined
              }
            >
              {name}
            </NativeLink>
          )
        } else {
          const TextWrapper = errorText ? ErrorText : Text
          return <TextWrapper key={i}>{s}</TextWrapper>
        }
      })}
    </>
  )
}
